<div class="page-container content-w-98">
    <div class="page-head">
        <div>
            <div class="page-title">
                <p class="headerName">{{headerData.materialName}}</p>
            </div>
        </div>
    </div>
    <div class="responsive-height" [ngClass]="{ 'disabled-project': productData?.isLockProject }">
        <div class="row">
            <div class="col-md-12"
                *ngrxLet="{ dataLoaded : (sharedFacade.isLoaded$ | async), isClearSearch:(sharedFacade.isClearSearch$ | async)} as sharedData">
                <piqet-angular-portlet [class]="'detail-cell-renderer'" [class]="'fixedHeight'"
                    [columnDefs]="columnDefs" [frameworkComponents]="frameworkComponents" [searchInputSize]="true"
                    (inlineDataEditEvent)="editRecord($event)" [headerBtn]="'Add new product'"
                    [gridData]="productData" [pageNo]="$any(productData)?.draw"
                    (openBtnModal)="addNewSubProduct()" [hidePagination]="true" [gridName]="gridName"
                    [hideSideBar]="isHideSideBar" [isClearSearch]="sharedData.isClearSearch" [isSetWidth]="false"
                    (changeRowOrder)="changeRowOrder($event)"></piqet-angular-portlet>
            </div>
        </div>
    </div>
</div>